// Allows the ability to lazyload google maps and add markers to the map only when the user scrolls close to the map element

/**
 * Basic map object takes jquery selector to find the map element
 * and a list of options to get passed directly into the map constructor
 * there are some default options set which can be overriden
 *
 * Also add the nopin attribute to all tiles to prevent them being picked
 * up by pinterest.
 *
 * @param  int      id
 * @param  object   options
 * @author Neil Brayfield <neil@d3r.com>
 */
var NewMap = function (id, options) {
    var self = this;
    var defaults = {
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        scrollwheel: false,
        mapTypeControl: false,
        streetViewControl: false,
        minZoom: 2
    };
    $.extend(defaults, options);
    this.mapDiv = $(id).get(0);

    if ('undefined' !== typeof this.mapDiv) {
        this.map = new google.maps.Map(this.mapDiv, defaults);
        this.markers = [];
        this.bounds = new google.maps.LatLngBounds();

        this.polyline = new google.maps.Polyline({
            path: [],
            geodesic: true,
            strokeColor: '#242526;',
            strokeOpacity: 1.0,
            strokeWeight: 2
        });

        this.polyline.setMap(this.map);
    }
};

/**
 * Place a marker and expand the polyline
 *
 * @param  object data
 * @author Neil Brayfield <neil@d3r.com>
 */
NewMap.prototype.addMarker = function(data, icon) {
    if ('undefined' === typeof this.mapDiv) {
        return;
    }

    var map = this.map;

    for (var i = 0; i < this.markers.length; i++) {
        var element = this.markers[i];
        if (element.data.lat == data.lat && element.data.lng == data.lng) {
            for (var i = 0; i < data.days; i++) {
                element.days.push(data.day+i);
            }

            this.addPath(data.lat, data.lng);

            this.updateLabel(element.marker, element.days);
            return;
        }
    }

    var path;
    var label = '';

    if (icon) {
        path = {
            url: '/images/icon-marker.png',
            size: new google.maps.Size(68, 98),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(0, 98)
        };
    } else {
        path = {
            path: 'M-22 -22 H 22 V 22 H -22 L -22 -22',
            fillColor: '#35393A',
            fillOpacity: 1,
            scale: 1,
            strokeColor: 'white',
            strokeWeight: 2
        };
        label =  {
            fontFamily: '"Merriweather", Georgia, Times new roman, serif',
            fontSize: '18px',
            color: 'white',
            text: data.day + ''
        };
    }

    var marker = new google.maps.Marker({
        position: new google.maps.LatLng(data.lat, data.lng),
        map: map,
        icon: path,
        label: label
    });

    marker.addListener('click', function() {
        $('#day-' + data.day).trigger('open');
    });

    this.addPath(data.lat, data.lng);


    var obj = {
        marker: marker,
        data: data,
        days: [data.day]
    };

    if (data.days > 1) {
        for (var i = 1; i < data.days; i++) {
            obj.days.push(data.day+i);
        }
    }

    if (!icon) {
        this.updateLabel(marker, obj.days);
    }

    this.markers.push(obj);
    this.bounds.extend(marker.getPosition());

    if (this.markers.length <= 1) {
        this.map.setCenter(marker.getPosition());
        this.map.setZoom(13);
    } else {
        this.map.fitBounds(this.bounds);
    }
};


/**
 * Add a path to the poly line
 *
 * @param int lat
 * @param int lng
 * @author Neil Brayfield <neil@d3r.com>
 */
NewMap.prototype.addPath = function(lat, lng) {
    if ('undefined' === typeof this.mapDiv) {
        return;
    }

    var currentPath = this.polyline.getPath();
    currentPath.push(new google.maps.LatLng(lat, lng));
    this.polyline.setPath(currentPath);
}

/**
 * Add label to marker
 *
 * @param Marker marker
 * @param array days
 * @author Neil Brayfield <neil@d3r.com>
 */
NewMap.prototype.updateLabel = function(marker, days) {
    if ('undefined' === typeof this.mapDiv) {
        return;
    }

    var label = days[0] + '';
    for (var i = 1; i < days.length; i++) {
        if (days[i-1] == days[i] - 1) {
            while (days[i-1] == days[i] - 1) {
                i++;
            }
            label += '-' + (days[i-1]);
            i--;
        } else {
            label += ', ' + days[i];
        }

    }

    var width = (label.length*12/2 < 22) ? 22 : label.length*12/2;
    var path = 'M-'+width+' -22 H '+width+' V 22 H -'+width+' L -'+width+' -22';

    marker.getIcon().path = path;
    marker.getLabel().text = label;
}

/**
 * Sets the center point with an offset in pixels
 *
 * @param  float lat
 * @param  float lng
 * @param  int   offsetX
 * @param  int   offsetY
 * @author Neil Brayfield <neil@d3r.com>
 */
NewMap.prototype.setCenterWithOffset = function(lat, lng, offsetX, offsetY) {
    if ('undefined' === typeof this.mapDiv) {
        return;
    }

    var map = this.map;
    var ov = new google.maps.OverlayView();
    ov.onAdd = function() {
        var proj = this.getProjection();
        var aPoint = proj.fromLatLngToContainerPixel(new google.maps.LatLng(lat, lng));
        aPoint.x = aPoint.x+offsetX;
        aPoint.y = aPoint.y+offsetY;
        map.setCenter(proj.fromContainerPixelToLatLng(aPoint));
    };
    ov.draw = function() {};
    ov.setMap(map);
};

TRIPSMITHS.GoogleMaps = TRIPSMITHS.GoogleMaps || {};

TRIPSMITHS.GoogleMaps.loadAPI = function(callback) {
    const scriptUrl = 'https://maps.google.com/maps/api/js?libraries=places&key=' + TRIPSMITHS.GoogleMaps.Key;

    var scriptExists = document.querySelector('script[src="' + scriptUrl + '"]');

    if (!scriptExists) {
        var tag = document.createElement('script');
        var firstScriptTag = document.getElementsByTagName('script')[0];

        tag.onload = callback;
        tag.src = scriptUrl;
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    } else {
        callback();
    }
};

TRIPSMITHS.GoogleMaps.addMap = function(elementSelector, config, markers) {
    const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                TRIPSMITHS.GoogleMaps.loadAPI(function () {
                    var map = new NewMap(elementSelector, config);

                    markers.forEach(function (marker) {
                        map.addMarker({
                            lat: marker.lat,
                            lng: marker.lng,
                            day: marker.day,
                            days: marker.days,
                        }, false);
                    });
                });
                observer.unobserve(entry.target);
            }
        });
    }, {rootMargin: '100%'})

    observer.observe(document.querySelector(elementSelector));
};
